export default __webpack_public_path__ + "static/media/typicalweek (2).0354bd0f.png";